import script from "./MoveCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveCounter.vue?vue&type=script&setup=true&lang=js"

import "./MoveCounter.vue?vue&type=style&index=0&id=1716206a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1716206a"]])

export default __exports__